import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=2a88eb88&scoped=true"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"
import style0 from "./PorEquipeAcs.vue?vue&type=style&index=0&id=2a88eb88&prod&lang=css"
import style1 from "./styles.scss?vue&type=style&index=1&id=2a88eb88&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88eb88",
  null
  
)

export default component.exports